import {EnvModel} from '@common/_models/core.models';

export const environment: EnvModel = {
    production: false,
    apiUrl: 'https://api.ovn.devserver.cc',
    ws: 'api.ovn.devserver.cc',
    homepageUrl: 'http://localhost:3000',
    standaloneData: {
        id: '',
        name: 'Ovnlogistics',
        favicon: './assets/favicon/o-150х150.png'
    }
};
